import {EventEmitter, Injectable, OnDestroy} from "@angular/core";
import {ErrorCodes} from "../../../../../common/enums/states/error-codes";
import {SalesDto} from "../../../../models/sales/sales-dto";

import {ChartData} from "chart.js/auto";
import {EventAnalysisStoreService} from "../../../../store/event-analysis-store.service";
import {LinkedDtoRepository} from "../../../../../common/repositories/linked-dto-repository";
import {SalesRepository} from "../../../../repositories/core/sales-repository/sales-repository";
import {ColorMapService} from "../../../../../common/colors/color-map.service";
import {DistributionDatasetProcessor} from "../utils/distribution-dataset-processor";
import {Subscription} from "rxjs";


@Injectable(
  /*{
  providedIn: 'root'
}*/
)
export class RevenueDistributionStore implements OnDestroy{
  dataset!: ChartData<"doughnut">
  selectedOption: keyof SalesDto = "compositionTypeId"
  options: {key: keyof SalesDto, description: string}[] = [
    {key: "locationId", description: "Umsatz pro Standort"},
    {key: "compositionTypeId", description: "Umsatz pro Kategorie"},
    //{key: "bookingType", description: "Umsatz pro Zahlungsmethode"}
  ]

  subscription: Subscription = new Subscription();
  isRegistered: boolean = false;
  updateNotifier: EventEmitter<any> = new EventEmitter<any>()
  errorCode: ErrorCodes | undefined = ErrorCodes.loading

  constructor(
    public eventAnalysisStoreService: EventAnalysisStoreService,
    private colorMapService: ColorMapService,
    private linkedDtoRepository: LinkedDtoRepository<any>,
    private salesRepository: SalesRepository
  ) {
    this.register();
  }

  update(){
    setTimeout(() => {
      this.dataset = this.processPieChart();
      this.verifyDatasetContainsOnlyPositiveValues()
      this.updateNotifier.emit();
    },0)
  }

  changeOption(option: keyof SalesDto){
    this.selectedOption = option;
    this.update();
  }

  processPieChart(): ChartData<"doughnut">{
    return DistributionDatasetProcessor.processPieChartDataset(this.selectedOption, this.salesRepository.getSalesWrapper(), this.linkedDtoRepository, this.colorMapService);
  }

  verifyDatasetContainsOnlyPositiveValues() {

    if(DistributionDatasetProcessor.verifyDatasetContainsOnlyPositiveValues(this.dataset) === false){
      this.errorCode = ErrorCodes.negativeValues
      this.dataset = { labels: [], datasets: [{ data: [] }] }
    }

  }

  ngOnDestroy() {

    this.subscription.unsubscribe()
  }

  initialize(){}

  register(): void {
    if(this.isRegistered)
      return
    this.isRegistered = true
    this.subscription.add(this.eventAnalysisStoreService.initializedNotifier.subscribe(() => {
        this.initialize()
      }
    ))

    this.subscription.add(this.eventAnalysisStoreService.updateNotifier.subscribe(() => {
        this.update()
      }
    ))

    this.subscription.add(this.eventAnalysisStoreService.errorNotifier.subscribe((errorCode) => {
        this.errorCode = errorCode
      }
    ))
  }
}
